async function loadAlmeHistory(almeApiUtils) {
    let curHistory = [];
    try {
        curHistory = await almeApiUtils.loadAlmeHistory();
        // Disable all auto navigation on history load.
        for (const response of curHistory) {
            if (response) {
                response.fromHistory = true;
                if (response.navUrl) {
                    response.navUrl.AutoNavigationType = 'None';
                }
            }
        }
    }
    catch (error) {
        console.error(error);
    }
    return curHistory;
}
export default loadAlmeHistory;
